import React from 'react';
import Modal from 'react-modal';
import { Typography, CircularProgress, withStyles } from '@material-ui/core';

const styles = {
    main: {
        display: 'flex',
        /* eslint-disable-next-line */
        flexDirection: 'column' as any as 'column',
        justifyContent: 'flex-end',
        alignContent: 'center',
    },
    mainRow: {
        width: '100%',
        margin: '10px',
    },
    modalColumn: {
        display: 'flex',
        /* eslint-disable-next-line */
        flexDirection: 'column' as any as 'column',
        justifyContent: 'center',
        alignContent: 'center',
    },

    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
    progress: {
        width: '50%',
        margin: '0 auto',
    },
};

export interface LoadingModalProps {
    /* eslint-disable-next-line */
    classes: any;
    label?: string;
    open: boolean;
    message: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ classes, label, open, message }) => {
    return (
        <Modal
            isOpen={open}
            style={styles}
            contentLabel={label || 'Loading'}
            ariaHideApp={false}
        >
            <div className={classes.main}>
                <div className={classes.modalColumn}>
                    <Typography> {message}</Typography>
                    <CircularProgress className={classes.progress} />
                </div>
            </div>
        </Modal>
    );
};

export default withStyles(styles)(LoadingModal);
